import React, { useState, useEffect, useRef } from "react";
import QrCode from "../assets/ScanQr.png";
import QR from "react-qr-code";
import {
  updateInfo,
  getUserInfov2,
  getFullNamev2,
  getEmailv2,
  getPreferedProgramv2,
  getNationalityv2,
  getPhoneNumberv2,
  getStatev2,
  getData,
  getSchoolPreference,
  getLevelOfStudy,
  getAttendance,
  getQueueStatus,
} from "../Function/getSubmissionI";
import { Dialog } from "@mui/material";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import { mpost } from "../Function/common";
import "../Css/Background.css";
// import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";
import EdiText from "react-editext";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import PersonIcon from "@mui/icons-material/Person";
import TaylorCampus2 from "../assets/TaylorCampus2.jpg";
import TaylorLogo from "../assets/logo_openday_white.png";
import Capture41 from "../assets/NewLogo3.png";
import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import { BiWifiOff } from "react-icons/bi";
// import { executeRecaptcha } from "../Function/recaptchaHelper";

const getQueueNumberApi = "https://taylor.qbe.ee/api_qapp/getqueueno";

function Homepage() {
  const [currentState, setCurrentState] = useState("standby");
  const [detected, setDetected] = useState(false);
  const [submission, setSubmission] = useState({});
  const [showDialog, setshowDialog] = useState(false);
  const [queue, setQueue] = useState({});
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState(" ");
  const [email, setEmail] = useState(" ");
  const [phone, setPhone] = useState(" ");
  const [nationality, setnationality] = useState("");
  const [state, setstate] = useState("");
  const [programme, setprogramme] = useState("");
  const [hide, sethide] = useState(false);
  const [hideName, sethideName] = useState(false);
  const [hideEmail, sethideEmail] = useState(false);
  const [qrvalue, setqrvalue] = useState("");
  const [hidephone, sethidePhone] = useState(false);
  const [loadingqueue, setloadingqueue] = useState(false);
  const [showElement, setShowElement] = useState(true);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [scanResult, setScanResult] = useState("");

  const checkInternetConnection = useRef(null);

  useEffect(() => {
    // document.title = "Taylor";
    window.addEventListener("keydown", handler, false);
    const timer = setTimeout(() => {
      setShowElement(false);
    }, 30000); // 5 minutes in milliseconds

    // Check for internet connectivity every 10 seconds
    const checkInternetConnection = setInterval(() => {
      const onlineStatus = navigator.onLine;
      if (isOnline !== onlineStatus) {
        setIsOnline(onlineStatus);
      }
    }, 10000);

    return () => {
      window.removeEventListener("keydown", handler, false);
      clearTimeout(timer);
      clearInterval(checkInternetConnection);
    };
  }, [isOnline]);

  const handler = async (e) => {
    const mval = localStorage.getItem("keyevent") ?? "";
    if (e.key === "Shift" || e.key === "NumLock") return;
    if (e.key === "Enter") {
      setqrvalue(mval);
      console.log(mval);
      //todo imolement here
      onScanner(mval);
      localStorage.removeItem("keyevent");
    } else {
      localStorage.setItem("keyevent", mval.concat(e.key));
    }
  };

  const onScanner = async (data) => {
    console.log("Last updated:", new Date(document.lastModified));
    console.log(detected);
    // if (detected === false) {
    setDetected(true);
    console.log("enter");
    setCurrentState("loading");

    const userInfo = await getUserInfov2(data);
    const queueStatus = await getQueueStatus(data);
    setLoading(false);

    // console.log(queueStatus);

    if (userInfo?.data?.id) {
      setCurrentState("success");
      setSubmission(userInfo);
      // setshowDialog(true);
      setName(getFullNamev2(userInfo));
      setEmail(getEmailv2(userInfo));
      setPhone(getPhoneNumberv2(userInfo));
      setScanResult(data);

      console.log("queueStatus", queueStatus);
      // Check the queue status
      if (queueStatus?.data?.[0]?.status_label === "Waiting" || queueStatus?.data?.status_label === "Waiting") {
        setLoading(true);
        setloadingqueue(true);
        setLoading(false);
        setloadingqueue(false);
        // console.log("Data already exists, skipping userInfo retrieval.");
        // setQueue(queueStatus?.data);
        console.log("waiting");
        console.log(queueStatus?.data[0]?.qr_info);
        console.log(queueStatus?.data?.qr_info);
        setQueue({
          queue_number: queueStatus?.data[0]?.queue_number || queueStatus?.data?.queue_number,
          qr_info: queueStatus?.data[0]?.qr_info || queueStatus?.data?.qr_info,
          message: "You Queue Number already in waiting list",
        });
        // console.log(queueStatus);
        // console.log(queueStatus?.data[0]?.qr_info);
        // console.log(queueStatus?.data[0]);
        setshowDialog(true);
        setLoading(false);
      } else {
        setshowDialog(true);
        setLoading(false);
      }
    } else {
      setCurrentState("failed");
      setDetected(false);
      console.log("called 1");
      setTimeout(() => {
        setCurrentState("standby");
      }, 10000);

      // show error
      return;
    }

    // console.log(submissionId);
    console.log(userInfo);
    // console.log(userAttendance);
    // }
  };

  const cancelButton = async (e, reason) => {
    console.log(reason);
    if (reason && reason === "backdropClick") return;

    setshowDialog(false);
    setCurrentState("standby");
    setDetected(false);
    console.log("called 2");
    setQueue({});

    // Reset all hide states to false
    sethide(false);
    sethideName(false);
    sethideEmail(false);
    sethidePhone(false);
  };

  const getEducationLevel = (input) => {
    //"pre-university","undergraduate","postgraduate","others"
    const keyword_preU = ["Foundation", "Diploma", "General Certificate of Education - Advanced Level (GCE A Level)", "South Australian Certificate of Education", "SACE", "ACCA", "Intensive English"];
    const keyword_undergrad = ["Bachelor", "Degree", "American Degree Transfer Program"];
    const keyword_master = ["Master", "Doctor"];

    const normalizeInput = input.toLowerCase();
    if (keyword_preU.some((keyword) => normalizeInput.includes(keyword.toLowerCase()))) return 3; //"pre-university";
    if (keyword_undergrad.some((keyword) => normalizeInput.includes(keyword.toLowerCase()))) return 4; //"undergraduate";
    if (keyword_master.some((keyword) => normalizeInput.includes(keyword.toLowerCase()))) return 5; //"postgraduate";
    return 6; //"others";
  };

  const onGetQueue = async () => {
    console.log("click ok");
    setLoading(true);
    setloadingqueue(true);
    // let stag = submission?.data?.nationality === "Malaysia" ? getEducationLevel(submission?.data?.programme_interest) : "others";
    const token = await executeRecaptcha("services");
    const data = {
      req_uid: "",
      client_id: "BXv4ZgmTCcrPOdcAx/5X3A==",
      country_code: "my",
      branch_id: "KwzlJVk8dnzF0ZTWHwNp8A==",
      department_id: "1",
      // service_id: "1",
      service_id: submission?.data?.nationality === "Malaysia" ? getEducationLevel(submission?.data?.programme_interest) : 6,
      // stag: stag,
      token: token,
      param_int_1: "YES",
      param_int_2: "0",
      param_int_3: "0",
      param_str_1: getNationalityv2(submission),
      param_str_2: getData(submission),
      // param_str_3: " ",
      language_id: " ",
      senderid: "senderid",
      customer_name: name,
      customer_id: email,
      customer_obj: email,
      phone_no: phone,
      rmk_1: getNationalityv2(submission),
      // rmk_2: getPreferedProgramv2(submission),
      // rmk_3: qrvalue,
      rmk_4: getPreferedProgramv2(submission),
      rmk_5: getLevelOfStudy(submission),
      rmk_6: getSchoolPreference(submission),
      //
      rmk_8: submission?.data?.guardian_mobile,
      rmk_9:`${submission?.data?.intake_month} ${submission?.data?.intake_year}`,
      param_str_3: qrvalue,
      catg_tag_2: getStatev2(submission),
    };
    console.log(data);
    const respond = await mpost(getQueueNumberApi, data);
    const userAttendance = await getAttendance(scanResult, { qr_info: respond?.data?.qr_info });
    console.log(userAttendance);
    // // Reset the hide state when getting the queue number
    // sethide(false);
    // sethideName(false);
    // sethideEmail(false);
    // sethidePhone(false);
    console.log("respond", respond);
    console.log(respond);
    console.log(respond?.data?.qr_info);
    console.log(respond?.data?.queue_number);

    if (respond.error_code === 13) {
      console.log("masuk function error code 13");
      setQueue({
        queue_number: respond?.queue_number,
        qr_info: respond?.data?.qr_info,
        message: "You Queue Number already in waiting list",
      });
    } else if (respond?.error_code === 17) {
      // console.log("masuk function error code 17");
      // console.log("respond", respond);
      // console.log("queue number", respond?.data?.queue_number);
      // console.log("qr_info", respond?.data?.qr_info);
      // setQueue({
      //   ...respond,
      //   ...{
      //     queue_number: respond?.data?.queue_number,
      //     qr_info: respond?.data?.qr_info,
      //     message: "You are limited to 1 visit per day.",
      //   },
      // });

      setQueue({
        queue_number: respond?.data?.queue_number,
        qr_info: respond?.data?.qr_info,
        // message: "You are limited to 1 visit per day.",
      });
    } else {
      setQueue({
        ...respond,
        ...{
          message: "Your Queue Number is ",
          qr_info: respond?.qr_info,
        },
      });
    }
    setloadingqueue(false);
    console.log(respond);

    setLoading(false);
    setTimeout(() => {
      onComplete();
    }, 300000);
  };

  const onComplete = () => {
    setSubmission({});
    setCurrentState("standby");
    setshowDialog(false);
    setDetected(false);
    console.log("called 3");
    setQueue({});

    // Reset all hide states to false
    sethide(false);
    sethideName(false);
    sethideEmail(false);
    sethidePhone(false);
  };

  const onSave = async (mkey, val) => {
    //access original data
    console.log(val);
    console.log(getPreferedProgramv2(submission));
    console.log(submission);

    let formData = {}; //new FormData();

    if (mkey === "name") {
      setName(formData.name);
    }
    if (mkey === "email") {
      setEmail(formData.email);
    }
    if (mkey === "phoneNum") {
      setPhone(formData.phone);
    }

    formData.name = mkey === "name" ? val : getFullNamev2(submission);
    formData.email = mkey === "email" ? val : getEmailv2(submission);
    formData.mobile_number = mkey === "phoneNum" ? val : getPhoneNumberv2(submission);
    formData.state = getStatev2(submission);
    formData.nationality = getNationalityv2(submission);
    formData.programme = getPreferedProgramv2(submission);

    const resp = await updateInfo(getData(submission), formData);
    setLoading(false);
    console.log(formData);
    console.log(mkey);
    console.log();
    console.log(resp);
  };

  const handleRefresh = () => {
    window.location.reload(); // Refresh the page
    setIsOnline(navigator.onLine); // Update the online status
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <img
        style={{
          position: "fixed",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          opacity: 0.2,
          zIndex: -1,
        }}
        alt=""
        src={TaylorCampus2}
      />
      <div
        style={{
          background: "#c12026",
          display: "flex",
          padding: "6px",
          justifyContent: "space-between",
        }}
      >
        <img
          style={{
            padding: "20px 10px 10px 22px",
            height: "110px",
            objectFit: "cover",
          }}
          src={TaylorLogo}
          alt=""
        />
        <img
          style={{
            width: "350px",
            height: "150px",
            justifyContent: "end",
            objectFit: "contain",
            objectPosition: "right",
          }}
          src={Capture41}
          onClick={() => {
            window.location.reload();
            console.log("test");
          }}
          alt=""
        />
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* <div
          style={{ position: "absolute", left: 0, bottom: 40, fontSize: 10 }}
          onClick={() => {
            window.location.reload();
            console.log("test");
          }}
        >
          Refresh
        </div> */}
        {showElement && (
          <p style={{ position: "absolute", left: 0, bottom: 10, fontSize: 10 }}>
            {/* Version 2.7 */}
            last update 25/11/2024
          </p>
        )}
        <div className="my-image">
          <div className="Container">
            <p className="my-text1">Welcome to Taylor’s Open Day</p>

            {currentState === "standby" ? (
              <>
                <p className="my-text2">Scan your QR code to continue</p>
                <img className="QrCode" src={QrCode} alt="" />
              </>
            ) : currentState === "loading" ? (
              <>
                <p className="my-text2">Searching for your info in our database...</p>
                <CircularProgress color="success" />
                <p style={{ fontSize: "18px", textAlign: "center" }}>Scanning {qrvalue}</p>
              </>
            ) : currentState === "failed" ? (
              <>
                <p className="my-text2">Sorry, we couldn't find your details. Please rescan the QR code. </p>
                <SentimentVeryDissatisfiedIcon />
              </>
            ) : loading ? (
              <p className="my-text2">Please wait and dont click cancel button</p>
            ) : (
              ""
            )}
          </div>
        </div>

        <Dialog onClose={cancelButton} open={showDialog} maxWidth="md" fullWidth={true}>
          <div className="DialogContainer">
            {Object.keys(queue).length === 0 ? (
              <div className="">
                {!hide && (
                  <>
                    <div className="GetNameText">Hello {name}</div>
                    <br />
                    <div className="my-text3">Please verify your information</div>
                    <br />
                  </>
                )}

                <div
                  style={{
                    display: hideName ? "none" : "flex",
                    width: 800,
                    alignItems: "center",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: 10,
                    gap: 10,
                    margin: "10px",
                  }}
                >
                  <PersonIcon sx={{ fontSize: 30, marginRight: "10px" }} />
                  <EdiText
                    hideIcons
                    inputProps={{
                      style: {
                        width: 570,
                        fontSize: 32,
                        fontWeight: "bold",
                      },
                    }}
                    viewProps={{
                      style: {
                        width: 710,
                        fontSize: 32,
                        fontWeight: "bold",
                      },
                    }}
                    type="text"
                    editButtonContent={
                      <EditIcon
                        style={{
                          height: "18px",
                          width: "18px",
                        }}
                      />
                    }
                    saveButtonContent={
                      <CheckIcon
                        style={{
                          height: "56px",
                          width: "50px",
                        }}
                      />
                    }
                    cancelButtonContent={
                      <ClearIcon
                        style={{
                          height: "56px",
                          width: "50px",
                        }}
                      />
                    }
                    value={getFullNamev2(submission)}
                    onSave={(val) => {
                      console.log(getData(submission));
                      onSave("name", val);
                      setName(val);
                      sethide(false);
                      sethideEmail(false);
                      sethidePhone(false);
                    }}
                    onEditingStart={(val) => {
                      console.log("edit name ", val);
                      sethide(true);
                      sethideEmail(true);
                      sethidePhone(true);
                    }}
                    onCancel={() => {
                      sethide(false);
                      sethideEmail(false);
                      sethidePhone(false);
                    }}
                  />
                </div>

                <div
                  style={{
                    margin: "10px",
                    display: hideEmail ? "none" : "flex",
                    width: 800,
                    alignItems: "center",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: 10,
                    gap: 10,
                  }}
                >
                  <EmailIcon sx={{ fontSize: 30, marginRight: "10px" }} />
                  <EdiText
                    hideIcons
                    inputProps={{
                      style: {
                        width: 570,
                        fontSize: 32,
                        fontWeight: "bold",
                      },
                    }}
                    viewProps={{
                      style: {
                        width: 710,
                        fontSize: 32,
                        fontWeight: "bold",
                      },
                    }}
                    type="text"
                    editButtonContent={
                      <EditIcon
                        style={{
                          height: "18px",
                          width: "18px",
                        }}
                      />
                    }
                    saveButtonContent={
                      <CheckIcon
                        style={{
                          height: "56px",
                          width: "50px",
                        }}
                      />
                    }
                    cancelButtonContent={
                      <ClearIcon
                        style={{
                          height: "56px",
                          width: "50px",
                        }}
                      />
                    }
                    submitOnEnter
                    startEditingOnFocus
                    editOnViewClick
                    value={getEmailv2(submission)}
                    validationMessage="Enter the Valid email only"
                    validation={(val) => /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(val)}
                    onSave={(val) => {
                      onSave("email", val);
                      setEmail(val);
                      sethide(false);
                      sethideName(false);
                      sethidePhone(false);
                    }}
                    onEditingStart={() => {
                      sethide(true);
                      sethideName(true);
                      sethidePhone(true);
                    }}
                    onCancel={() => {
                      sethide(false);
                      sethideName(false);
                      sethidePhone(false);
                    }}
                  />
                </div>

                <div
                  style={{
                    display: hidephone ? "none" : "flex",
                    width: 800,
                    alignItems: "center",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: 10,
                    gap: 10,
                    margin: "10px",
                  }}
                >
                  <LocalPhoneIcon sx={{ fontSize: 30, marginRight: "10px" }} />
                  <EdiText
                    hideIcons
                    inputProps={{
                      style: {
                        width: 570,
                        fontSize: 32,
                        fontWeight: "bold",
                      },
                    }}
                    viewProps={{
                      style: {
                        width: 710,
                        fontSize: 32,
                        fontWeight: "bold",
                      },
                    }}
                    type="text"
                    editButtonContent={
                      <EditIcon
                        style={{
                          height: "18px",
                          width: "18px",
                        }}
                      />
                    }
                    saveButtonContent={
                      <CheckIcon
                        style={{
                          height: "56px",
                          width: "50px",
                        }}
                      />
                    }
                    cancelButtonContent={
                      <ClearIcon
                        style={{
                          height: "56px",
                          width: "50px",
                        }}
                      />
                    }
                    editOnViewClick
                    value={getPhoneNumberv2(submission)}
                    validationMessage="Enter the Valid number only"
                    validation={(val) => /^\+?\d{1,3}[-.\s]?\d{3,4}[-.\s]?\d{4}$/.test(val)}
                    onSave={(val) => {
                      onSave("phoneNum", val);
                      setPhone(val);
                      sethide(false);
                      sethideEmail(false);
                      sethideName(false);
                    }}
                    onEditingStart={() => {
                      sethide(true);
                      sethideName(true);
                      sethideEmail(true);
                    }}
                    onCancel={() => {
                      sethide(false);
                      sethideEmail(false);
                      sethideName(false);
                    }}
                  />
                </div>
                <br />
                <div className="my-text3">Take queue number now?</div>
                <br />
              </div>
            ) : (
              <>
                {queue?.error ? (
                  <div>{queue?.error}</div>
                ) : (
                  <>
                    <div className="GetNameText">Hello {name}</div>
                    <div className="my-text4">{queue?.message}</div>
                    <div className="my-text5">{queue?.queue_number}</div>
                    <div
                      style={{
                        padding: "4px",
                        background: "white",
                        textAlign: "center",
                        justifyContent: "center",
                        borderRadius: "4px",
                        height: "148px",
                        width: "148px",
                        margin: "16px",
                      }}
                    >
                      <QR size={140} style={{}} value={`https://q04-my.qbe.ee/taylor/q/${encodeURIComponent(queue?.qr_info)}`} viewBox={`0 0 256 256`} />
                    </div>
                    <div className="textEdit1">
                      <p>
                        SMS will be sent to your registered number.
                        <br />
                        Please check your SMS for live queue status.
                      </p>
                      <br />
                    </div>
                  </>
                )}
              </>
            )}
            <Stack direction="row" spacing={4}>
              {Object.keys(queue).length === 0 ? (
                <>
                  <Button style={{ width: "100px", fontSize: "20px" }} variant="contained" color="success" onClick={onGetQueue} size="large">
                    {loadingqueue ? <CircularProgress /> : "OK"}
                  </Button>
                  <Button style={{ width: "100px", fontSize: "20px" }} variant="outlined" color="error" onClick={cancelButton} size="large">
                    CANCEL
                  </Button>
                </>
              ) : loading ? (
                <div>Loading...</div>
              ) : (
                <>
                  <Button style={{ width: "100px" }} variant="contained" color="success" onClick={onComplete}>
                    OK
                  </Button>
                </>
              )}
            </Stack>
          </div>
        </Dialog>
      </div>
      {isOnline && (
        <Dialog style={{ padding: "15px", background: "red" }} open={!isOnline} onClose={() => {}}>
          <div style={{ textAlign: "center" }}>
            <BiWifiOff style={{ fontSize: "50px" }} />
          </div>
          <DialogTitle
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            Internet Connection lost
          </DialogTitle>
          <DialogContent>
            <DialogContentText style={{ textAlign: "center", fontSize: "14px" }}>You have lost connection with the server .Check your internet connection and refresh</DialogContentText>
          </DialogContent>
          <Button style={{ background: "gray" }} variant="contained" color="primary" onClick={handleRefresh}>
            Refresh
          </Button>
        </Dialog>
      )}
    </div>
  );
}

export default Homepage;
